import React from "react";
import { Card } from "antd";
import KoIcon from '@kwapio/icons';
import styles from './card.module.scss';


function KoCard(props) {
  const { className = '', children,
    backgroud, icon, hoverable,
    cardBg = false,
    loading = false, ...rest } = props;
  return (<Card
    variant="borderless"
    className={`${styles.wraper} ${cardBg ? styles.card :''} ${hoverable ? styles.hover : ''} ${className ? className : ''}`}
    loading={loading} hoverable={hoverable}  {...rest}>
    {children}
    {icon && <div className={styles.icon} style={{ background: backgroud }}>
      <KoIcon name={icon} height={14} width={14} />
    </div>}
  </Card>);
}

export default KoCard;